// extracted by mini-css-extract-plugin
module.exports = {"description":"ProductDetailsHeader_description__b312e"};